import React from 'react';
import { Link } from 'react-router-dom';
import AdCreateForm from '../components/ads/AdCreateForm';
import { AdShare } from '../components/ads/AdShare';

const Share: React.FC = () => {
  return (
    <main className="bg-slate-50 dark:bg-slate-900">
      <div className="mx-auto max-w-5xl px-4 py-6 space-y-6 sm:py-8">
        <header className="flex items-start justify-between gap-4">
          <div className="space-y-1">
            <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 sm:text-3xl">Share your ad</h1>
            <p className="max-w-2xl text-sm text-slate-600 dark:text-slate-400">
              Create a new TELLURVISION creative, then generate links and social posts to share it
              across your channels.
            </p>
          </div>
          <Link
            to="/"
            className="inline-flex items-center rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-1.5 text-xs font-medium text-slate-700 dark:text-slate-300 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Go home
          </Link>
        </header>

        <AdCreateForm />

        <section className="grid gap-4 md:grid-cols-2">
          <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4 shadow-sm">
            <AdShare />
          </div>
        </section>
      </div>
    </main>
  );
};

export default Share;
